import { render, staticRenderFns } from "./FormsSkalyPo.vue?vue&type=template&id=03b66444&"
import script from "./FormsSkalyPo.vue?vue&type=script&lang=js&"
export * from "./FormsSkalyPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports